import { selfAxios } from "../../../../../axios/selfAxios.js";
async function reqGetOrgById(params) {
  const { data } = await selfAxios.get(`/ucenterapi/internal/org/getOrgById`, { params });
  return data == null ? void 0 : data.data;
}
export { reqGetOrgById };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/ucenterapi/internal/org/getOrgById/get.js